import {Component} from '@angular/core';
import {finalize} from 'rxjs/operators';
import {ShoppingService} from '@app/shopping/shopping.service';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ShoppingModel} from '../../models/shopping.model';
import {ChainService} from '@app/chain/chain.service';
import {DomainService} from '@app/core/domain/domain.service';
import {PlaceServiceBase} from '@app/core/places.service';
import {VouchersModel} from '../../models/vouchers.model';
import * as jspdf from 'jspdf';
import * as html2canvas from 'html2canvas';
import {AuthenticationService, Credentials} from '@app/core';
@Component({
  selector: 'app-shopping-cupons',
  templateUrl: './shopping-vouchers.component.html',
  styleUrls: ['./shopping-vouchers.component.scss']
})
export class ShoppingVouchersComponent {
  shoppingId: string;
  shopping: ShoppingModel;
  vouchers: VouchersModel[];
  selectedItem: VouchersModel;
  modalReference: NgbModalRef;
  loadingVouchers = true;
  isLoadingList = true;
  status = '1';
  contentVouchers: any;
  qrcode: string = null;
  user: Credentials;
  placeService: PlaceServiceBase;
  isShoppingDomain: boolean;
  currentDate = new Date();
  constructor(private shoppingService: ShoppingService,
              private chainService: ChainService,
              private domainService: DomainService,
              private route: ActivatedRoute,
              private modalService: NgbModal,
              private router: Router,
              private authenticationService: AuthenticationService) {
    this.isShoppingDomain = domainService.isShoppingDomain();
    this.placeService = this.isShoppingDomain ? shoppingService : chainService;
    this.route.params.subscribe(params => {
      this.loadShoppingVouchers(params.shoppingId);
      this.user = this.authenticationService.credentials;
    });
  }

  setFilter(status: string) {
    this.status = status;
    this.placeService.getVouchers(this.shoppingId, this.status)
      .pipe(finalize(() => {
      }))
      .subscribe(vouchers => {
        this.vouchers = vouchers;
      }, error => {
        console.log(`shopping error: ${error}`);
      });

  }

  navbarLeftText() {
    return `${(this.vouchers ? this.vouchers.length : 0)} Vouchers de prêmios instantâneos`;
  }

  loadShoppingVouchers(shoppingId: string) {
    this.isLoadingList = true;
    this.shoppingId = shoppingId;
    this.placeService.getShopping(shoppingId)
      .pipe(finalize(() => {
      }))
      .subscribe(shopping => {
        this.shopping = shopping;
        this.isLoadingList = false;
      }, error => {
        console.log(`shopping error: ${error}`);
      });

    this.placeService.getVouchers(shoppingId, this.status.toString())
      .pipe(finalize(() => {
      }))
      .subscribe(vouchers => {
        this.vouchers = vouchers;
      }, error => {
        console.log(`shopping error: ${error}`);
      });
  }

  openModal(content: any, item: VouchersModel) {
    this.currentDate = new Date();
    this.loadingVouchers = false;
    this.selectedItem = item;
    this.qrcode = btoa(JSON.stringify({
      contemplated: this.selectedItem.contemplated,
      id_hash: this.selectedItem.id_hash
    }));
    this.modalReference = this.modalService.open(content, {windowClass: 'modal-content{width: 67% !important;} modal-centered modal-md'});
  }

  getImageBackground(scratch: VouchersModel) {
    let url = '/assets/raspadinhabg.png';
    if (this.status === '2') {
      url = '/assets/raspadinhaitembg_green.png';
    }
    return `url(\"${url}\") center no-repeat`;
  }
  getImage(scratch: VouchersModel) {
    return `url(\"${scratch.campaignImage}\") center no-repeat`;
  }

  public captureScreen(item: VouchersModel) {
    const data = document.getElementById('contentToPDF');
    html2canvas(data).then((canvas: HTMLCanvasElement) => {
      // Few necessary setting options
      const imgWidth = 300;
      const pageHeight = 295;
      const imgHeight = canvas.height * imgWidth / canvas.width;
      const heightLeft = imgHeight;

      const contentDataURL = canvas.toDataURL('image/png')
      const pdf = new jspdf('p', 'pt', 'a4'); // A4 size page of PDF
      const position = 0;
      pdf.autoPrint();
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
      pdf.save('Prêmio.pdf'); // Generated PDF
    });
  }

}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/shopping-vouchers/shopping-vouchers.component.ts